<div class="global-checklist-dialog">
  <div class="global-checklist-dialog__header">
    <span class="global-checklist-dialog__title">Создание чек-листа</span>
    <app-icon class="global-checklist-dialog__close-icon" [size]="'24'" [glyph]="'close'" (click)="activeModal.close()"></app-icon>
  </div>

  <div class="global-checklist-dialog__content">
    <form [formGroup]="form" class="global-checklist-dialog__form">
      <app-field class="global-checklist-dialog__control">
        <input class="input-text" placeholder="Введите название чек-листа" maxlength="150" formControlName="name" />
      </app-field>

      <ui-multicombobox
        class="global-checklist-dialog__control"
        textKey="name"
        defaultText="Подтип глобальной проблемы"
        name="checklist-type-dialog"
        (callback)="handleChangeSubtype($event)"
        [items]="transformedGpSubtypes | func: cloneDeep"
        [initBy]="selectedGPSubtypes"
        [nullChoice]="false"
        [isDisabled]="false"
      >
      </ui-multicombobox>
    </form>
  </div>

  <div class="global-checklist-dialog__footer">
    <div class="global-checklist-dialog__actions">
      <button type="submit" class="button global-checklist-dialog__submit" (click)="handleSubmit()" [disabled]="form.invalid">Сохранить</button>
      <a class="link link--dotted-gray-dark global-checklist-dialog__cancel" (click)="activeModal.close()"> Отмена </a>
    </div>
  </div>
</div>
